$(function () {
  var screenHeight = $(window).height();
  $(window).scroll(function () {

    // 【条件】スクロール位置が1画面分を超えた場合
    if ($(this).scrollTop() > screenHeight) {
      // ヘッダーをオン状態にする
      $("header").addClass("header-switch");
      
    } else {
      // 【条件】スクロール位置が1画面分以内に戻った場合
      // ヘッダーをオフ状態に戻す
      $("header").removeClass("header-switch");
    }
  });
});

// $(window).on('load', function() {
//   const $splash = $('#splash');
//   setTimeout(() => {
//     $splash.fadeOut(1000);
//   }, 2000);
// });

$(window).on('load', function() {
  const $splash = $('#splash');
  const $splashImg = $('#splash img'); 
  $splashImg.fadeTo(2000, 1.0, function() {
    setTimeout(() => {
      $splash.fadeOut(1000);
    }, 1000);
  });
});


// adobe fonts
(function(d) {
  var config = {
    kitId: 'ykf5hmd',
    scriptTimeout: 3000,
    async: true
  },
  h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);


// toggle

$(function () {
  $('#toggle').click(function () {
    $("html").toggleClass('open');
  });
  $('nav ul li a').click(function () {
    $('html').removeClass('open');
  });
});

// header effect

var menuHeight = $("header").height();
var startPos = 0;
$(window).scroll(function () {
  var currentPos = $(this).scrollTop();
  if (currentPos > startPos) {
    if ($(window).scrollTop() >= 800) {
      $("header").css("top", "-" + menuHeight + "px");
    }
  } else {
    $("header").css("top", 0 + "px");
  }
  startPos = currentPos;
});


//slick

// トップカバー

$(function() {
  const fadeSpeed = 800;
  const delayFirst = 4000;
  const interval = 2000;
  let showingLeft = true;

  $('.slide-left, .slide-right').slick({
    fade: true,
    arrows: false,
    autoplay: false,
    speed: fadeSpeed,
    cssEase: 'linear',
    pauseOnHover: false
  });

  function nextSlide() {
    if (showingLeft) {
      $('.slide-left').slick('slickNext');
    } else {
      $('.slide-right').slick('slickNext');
    }
    showingLeft = !showingLeft;
  }

  setTimeout(function run() {
    nextSlide();
    setInterval(nextSlide, interval);
  }, delayFirst);
});


// カバー

$('.slide').slick({
  fade: true,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnFocus: false,
  pauseOnHover: false,
  speed: 1000,
});

// カルーセル

$('.carousel').slick({
  centerMode: true,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 260,
  centerPadding: '80px',
  slidesToShow: 4,
  pauseOnFocus: false,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 559,
      settings: {
        slidesToShow: 1
      }
    }]
});